(function() {
    'use strict';

    function validateFormBeforeSubmit(form) {
        if (window.PublicFormValidation && typeof window.PublicFormValidation.validateForm === 'function') {
            return window.PublicFormValidation.validateForm(form);
        }

        if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
            if (typeof form.reportValidity === 'function') {
                form.reportValidity();
            }
            return false;
        }

        return true;
    }

    function validateConsentBeforeSubmit(consentCheckbox) {
        if (window.PublicFormValidation && typeof window.PublicFormValidation.validateConsentCheckbox === 'function') {
            return window.PublicFormValidation.validateConsentCheckbox(consentCheckbox);
        }

        return !!consentCheckbox?.checked;
    }

    function clearConsentError(consentCheckbox) {
        if (window.PublicFormValidation && typeof window.PublicFormValidation.clearConsentValidation === 'function') {
            window.PublicFormValidation.clearConsentValidation(consentCheckbox);
            return;
        }

        consentCheckbox?.classList.remove('is-invalid');
    }

    if (typeof window !== 'undefined') {
        window.AjaxFormRuntime = window.AjaxFormRuntime || {
            bindSubmit: function(form, config) {
            if (!form || !config) {
                return;
            }

            const {
                formId,
                collectValues,
                buildRequest,
                getFetchArgs,
                onBeforeSubmit,
                onSuccess,
                minLoadingMs = 1200
            } = config;

            form.addEventListener('submit', async function(e) {
                e.preventDefault();

                const consentCheckbox = document.getElementById('consent-' + formId);
                const isConsentValid = validateConsentBeforeSubmit(consentCheckbox);
                const isFormValid = validateFormBeforeSubmit(form);
                if (!isConsentValid || !isFormValid) {
                    return;
                }

                clearConsentError(consentCheckbox);

                if (onBeforeSubmit && typeof onBeforeSubmit === 'function') {
                    const continueSubmit = onBeforeSubmit(form, formId);
                    if (continueSubmit === false) {
                        return;
                    }
                }

                const formSubmitState = window.FormSubmitState;
                if (formSubmitState) {
                    await formSubmitState.setLoading(form);
                }

                try {
                    const values = collectValues(formId, document);
                    const requestData = buildRequest(values, consentCheckbox.checked, {
                        pageUrl: window.location.href
                    });

                    const [endpoint, fetchInit] = getFetchArgs(requestData, values, form);
                    const token = form.querySelector('input[name="__RequestVerificationToken"]')?.value || '';

                    if (fetchInit.headers && !fetchInit.headers['RequestVerificationToken']) {
                        fetchInit.headers['RequestVerificationToken'] = token;
                    }

                    const response = await fetch(endpoint, fetchInit);

                    if (!response.ok) {
                        const errorData = await response.json().catch(() => ({}));
                        throw new Error(errorData.message || `HTTP ${response.status}: ${response.statusText}`);
                    }

                    const result = await response.json();

                    await formSubmitState.waitForMinimumLoadingDuration(form, minLoadingMs);

                    if (result.success) {
                        if (formSubmitState) {
                            formSubmitState.setSuccess(form);
                        }

                        form.reset();

                        if (onSuccess && typeof onSuccess === 'function') {
                            onSuccess(form, result);
                        }
                    } else {
                        if (formSubmitState) {
                            formSubmitState.setError(form, result.message || 'Произошла ошибка. Попробуйте еще раз.');
                        } else {
                            throw new Error(result.message || 'Произошла ошибка. Попробуйте еще раз.');
                        }
                    }
                } catch (error) {
                    const fallbackMessage = 'Произошла ошибка при отправке. Попробуйте еще раз.';
                    if (formSubmitState) {
                        await formSubmitState.waitForMinimumLoadingDuration(form, minLoadingMs);
                    }
                    if (formSubmitState) {
                        formSubmitState.setError(form, error && error.message ? error.message : fallbackMessage);
                    }
                }
            });
        }
    };
    }
})();
